import { Pipe, PipeTransform } from '@angular/core';
import { CustomFieldUtility } from '@jms/model';

@Pipe({
    name: 'customFieldType',
    standalone: false
})
export class CustomFieldTypePipe implements PipeTransform {

    transform(value: any): any {
        return CustomFieldUtility.getFieldType(value);
    }
}
